import { IconWrapper } from '../runtime';
export default IconWrapper('import', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2.75 8.49976H8.38M8.38 8.49976L6.38 6.5M8.38 8.49976L6.38 10.5",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 5.99973V3.24973C2.75 2.4213 3.42157 1.74973 4.25 1.74973H9.87868C10.2765 1.74973 10.658 1.90776 10.9393 2.18907L12.8107 4.06039C13.092 4.34169 13.25 4.72322 13.25 5.12105V12.7497C13.25 13.5782 12.5784 14.2497 11.75 14.2497H4.25C3.42157 14.2497 2.75 13.5782 2.75 12.7497V10.9997",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});